<!--导出字段勾选组件-->
<template>
    <span>
        <el-button :type="buttonType" size="small" @click="dialogImportVisible = true" :loading="importLoading">{{buttonText}}</el-button>
        <el-dialog :title="dialogTitle" :visible.sync="dialogImportVisible" @close="resetDialog" width="30%" center>
            <input type="file" ref="fileInput" @change="handleFileChange" style="display: none"/>
            <div>
                <el-input v-model="filePath" size="small" style="width: 60%;margin-right: 30px;" readonly></el-input>
                <el-button type="primary" @click="chooseFile" size="small">选择文件.xlsx</el-button>
            </div>
            <ExportFile v-if="templateFileUrl" :url="templateFileUrl" :params="params" :filename="dialogTitle + '模板'" :buttonName="dialogTitle + '模板下载.xlsx'" buttonType="text"></ExportFile>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogImportVisible = false">取消</el-button>
                <el-button type="primary" @click="importFile" :disabled="importDisabled" :loading="importLoading">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="系统提示" :visible.sync="dialogImportError" @close="resetErrorDialog" width="80%" center>
            <el-row type="flex" class="row-bg" justify="center">
                <el-col :span="8"><div class="grid-content">警告，检测到以下行数存在异常，请处理后重新导入</div></el-col>
            </el-row>
            <el-table size="mini" style="width:100%" :data="err_data" max-height="500">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column v-for="(value, key) in err_fields" :key="key" :prop="key" :label="value"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogImportError = false">取消</el-button>
                <el-button type="primary" @click="saveErrData" :loading="saveErrDataLoading">导出异常数据</el-button>
            </span>
        </el-dialog>
    </span>
</template>
<style scoped>
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  color: #D9001B;
}
.row-bg {
    padding: 7px 0;
    background: rgba(254, 240, 240, 1);
}
</style>
  
  <script>
  import http from '~/common/http'
  import XLSX from 'xlsx';
  import ExportFile from "~/widgets/ExportFile.vue";
  export default {
    name: "ImportFile",
    components: {
        ExportFile,
    },
    props: {
        buttonType: {
            type: String,
            default: 'primary',
        },
        buttonText: {
            type: String,
            default: '批量导入',
        },
        dialogTitle: {
            type: String,
            default: '导入',
        },
        templateFileUrl: {
            type: String,
            default: '',
        },
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
        url: {
            type: String,
            required: true,
        },
        err_fields: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        }
    },
    data() {
      return {
        //定义变量
        importLoading: false,
        dialogImportVisible: false,
        filePath: '',
        excelData: [],
        importDisabled: true,
        err_data: [],
        dialogImportError: false,
        saveErrDataLoading: false,
        // err_fields: {
        //     line_num: '行数',
        //     error_str: '异常原因',
        //     order_id: '订单ID',
        //     customer_name: '客户名称',
        //     send_type: '寄件类型',
        //     send_at: '寄出日期',
        //     express_way: '寄件方式',
        //     express_no: '快递单号',
        //     express_status: '签收状态',
        // },
      };
    },
  
    created: function () {
    },

    methods: {
        chooseFile() {
            this.$refs.fileInput.click();
        },

        resetDialog() {
            this.dialogImportVisible = false;
            this.filePath = "";
            this.$refs.fileInput.value = "";
            this.excelData = [];
            this.importDisabled = true;
        },

        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    // 将 Excel 表格转换为 JSON 数据
                    this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false, raw: false });
                    if (this.excelData.length > 0) {
                        this.importDisabled = false;
                    }
                    console.log("导入文件信息：", this.excelData);
                };
                reader.readAsArrayBuffer(file);
                this.filePath = file.name;
            }
        },

        importFile() {
            this.exportButtonLoading = true;
            let post_params = _.clone(this.params);
            if(post_params == undefined) post_params = {};
            const list = this.excelData.filter((obj) => Object.keys(obj).length > 0);
            post_params['import_data'] = list;
            if (!list || list.length < 1) {
                this.$message({
                    message: "导入数据表格不能为空",
                    type: "warning",
                });
                return false;
            }
            if (list.length > 2001) {
                this.$message({
                    message: "数据量过大，单次最多2000条记录",
                    type: "warning",
                });
                return false;
            }
            this.importLoading = true;
            http.post(this.url, post_params).then((res) => {
                this.importLoading = false;
                if (res.code == 0) {
                    this.$message({
                        message: "导入成功",
                        type: "success",
                    });
                    //自定义事件，提示父组件导入成功，刷新列表
                    this.$emit("import_success");
                    this.resetDialog();
                }else if(res.code == 4220){
                    this.$message({
                        message: '导入失败，数据不符请检查!',
                        type: 'warning'
                    });
                    this.err_data = res.data;
                    this.dialogImportError = true;
                }
            }).catch(error => {
                this.importLoading = false;
                console.error(err);
            });
        },

        resetErrorDialog(){
            this.err_data = [];
        },

        saveErrData(){
            if(!this.err_data || this.err_data.length < 1){
                this.$message({
                    message: "无异常数据",
                    type: "error"
                });
                return false;
            }
            this.saveErrDataLoading = true;
            // 创建一个工作簿
            const workbook = XLSX.utils.book_new();
            const sheetName = 'Sheet1';
            // 创建表头行
            var header = [];
            var fields = [];
            var data_concat = [];
            for (const [key, value] of Object.entries(this.err_fields)) {
                header.push(value);
                fields.push(key);
                console.log(`Key: ${key}, Value: ${value}`);
            }
            // 将表头行和 JSON 数据一起放入一个数组
            this.err_data.forEach((item, index) => {
                var values = [];
                fields.forEach(function(field) {
                    values.push(item[field])
                });
                data_concat.push(values);
            });
            const data = [header].concat(data_concat);
            // const data = [header].concat(this.err_data.map(item => [item.line_num, item.error_str, item.contact_name, item.mobile, item.qq, item.customer_name, item.customer_type_str, item.district_str, item.product_name, item.source_str]));
            // 将数据数组转换为工作表
            const worksheet = XLSX.utils.aoa_to_sheet(data);
            // 将工作表添加到工作簿
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            // 将工作簿保存为Excel文件
            XLSX.writeFile(workbook, this.dialogTitle + '异常数据表.xlsx');
            this.saveErrDataLoading = false;
        }
    }
  };
  </script>


// WEBPACK FOOTER //
// src/widgets/ImportFile.vue